/*
 * audit-logs (schema)
 */
import {
	boolean,
	jsonb,
	text,
	timestamp,
	uuid,
	varchar,
} from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"

export const auditLogs = schema.table("audit_logs", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),
	// --- General ---
	platform: varchar("platform").notNull(),
	timestamp: timestamp("timestamp", { withTimezone: true }).notNull(),
	operationType: varchar("operation_type", {
		enum: ["QUERY", "QUERY_ALL", "CREATE", "UPDATE", "DELETE", "ACTION"],
	}).notNull(),
	tableName: varchar("table_name").notNull(),
	operationName: varchar("operation_name").notNull(),
	recordId: uuid("record_id"),
	// --- Data Payload ---
	oldRecordData: jsonb("old_record_data"), // NULL for INSERTs
	newRecordData: jsonb("new_record_data"), // NULL for DELETEs
	// --- User Context ---
	userId: uuid("user_id").references(() => users.id, { onDelete: "set null" }),
	userIpAddress: text("user_ip_address"),
	userAgent: text("user_agent"),
	// --- System ---
	active: boolean("active").notNull().default(true),
})
